export default __webpack_public_path__ + "static/media/box-5Closed.625688a4.jpg";